import IMask from 'imask';
//import lightGallery from 'lightgallery';
//import lgFullscreen from 'lightgallery/plugins/fullscreen';
import { Modal } from 'bootstrap/js/dist/modal';
//import Modal from 'bootstrap/js/dist/modal'

/* import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger'; */

import Swiper from 'swiper';
//import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import { Scrollbar, Mousewheel } from 'swiper/modules';

//Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);
Swiper.use([Scrollbar, Mousewheel]);

// Инициализация при загрузке DOM-дерева
document.addEventListener('DOMContentLoaded', () => {
  //gsap.registerPlugin(ScrollTrigger);

  initTelMasks();
  //initLightGalleries();
  //initTemplateSlider();
  initPolaroidSlider();

  initScrollTriggers('[data-trig-line]');

  //document.querySelectorAll('form').forEach((el) => el.reset());
  document
    .querySelectorAll('form')
    .forEach((el) => el.addEventListener('submit', submitForm));
});

// Функция инициализации масок телефонных номеров
function initTelMasks() {
  const telInputs = document.querySelectorAll('input[type=tel]');
  telInputs.forEach((el) => {
    IMask(el, {
      mask: '+{7} 000 000 00 00',
    });
  });
}

// Функция инициализации галерей изображений
function initLightGalleries() {
  const galleryElements = document.querySelectorAll('[data-gallery]');
  galleryElements.forEach((el) => {
    lightGallery(el, {
      licenseKey: '0000 0000 0000 0000',
      download: false,
      fullScreen: false,
      plugins: [lgFullscreen],
      selector: '[data-src]',
    });
  });
}

function initTemplateSlider() {
  const slider = new Swiper('.slider-template', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1,
    speed: 400,
    autoplay: {
      delay: 5000,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}

function initPolaroidSlider() {
  const sliderPolaroid = new Swiper('.slider-polaroid', {
    watchSlidesProgress: true,
    loop: false,
    spaceBetween: 0,
    speed: 400,

    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    mousewheel: {
      invert: false,
      releaseOnEdges: true,
    },
    breakpoints: {
      // when window width is >= 320px
      100: {
        slidesPerView: 'auto',
        spaceBetween: 10,
      },
      /*  350: {
      slidesPerView: 2,
      spaceBetween: 10,
      }, */

      /* 576: {
      slidesPerView: 2,

      }, */
      768: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });
}

const initScrollTriggers = (target) => {
  const targets = document.querySelectorAll(target);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('triggered');
        observer.unobserve(entry.target); // Удаляет наблюдение после активации анимации
      }
    });
  });

  targets.forEach((box) => {
    observer.observe(box); // Начинаем наблюдение за каждым элементом
  });
};

const submitForm = (e) => {
  e.preventDefault();

  const thisEl = e.currentTarget;
  const formData = new FormData(thisEl);
  const name = formData.get('name');
  const surname = formData.get('surname');
  const phone = formData.get('phone');
  const drinks = formData.getAll('drinks');
  const text = formData.get('text');

  const message = `Новое сообщение:\nИмя: ${name}\nФамилия: ${surname}\nТелефон: ${phone}\nНапиток: ${drinks}\nТекст: ${text}`;

  const botToken = '8088229736:AAHhaYP4UDmGrtF1gP8Dsw-9L-1TeBysOZ4';

  const chatId3 = '1012193'; // Art
  const chatId1 = '816289192'; // Client
  const chatId2 = '487804034'; // Anna

  fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      chat_id: chatId1,
      text: message,
      parse_mode: 'HTML', // Опционально, можно убрать если не нужно форматирование
    }),
  })
    .then((response) => {
      if (response.ok) {
        //alert('Сообщение отправлено!');
        thisEl.reset(); // Сброс формы
        thisEl.querySelector('.btn-success').click();
      } else {
        alert('Ошибка при отправке сообщения.');
      }
    })
    .catch((error) => {
      console.error('Ошибка:', error);
      alert('Ошибка при отправке сообщения.');
    });

  fetch(`https://api.telegram.org/bot${botToken}/sendMessage`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      chat_id: chatId2,
      text: message,
      parse_mode: 'HTML', // Опционально, можно убрать если не нужно форматирование
    }),
  });
};

// Экспорт модального окна для доступа извне
window.modal = Modal;
